import keycloak from 'keycloak-js';
var host = window.location.host;
var realm = process.env.VUE_APP_REALM ? process.env.VUE_APP_REALM : host.split('.')[0];
let initOptions = { url: process.env.VUE_APP_KEYCLOAK_BASE_URL , realm: realm , clientId : 'mms' ,onload: 'login-required' , checkLoginIframe:false}

let keyCloak = keycloak(initOptions);

export default keyCloak;